export const GLOBAL_CHANGE_FILTERS = 'global/CHANGE_FILTERS'
export const GLOBAL_CHANGE_LANGUAGE = 'global/CHANGE_LANGUAGE'
export const GLOBAL_CLOSE_ARTICLES = 'global/CLOSE_ARTICLES'
